import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { IoIosInformationCircleOutline } from "react-icons/io";
import { showErrorNotification, showInfoNotification, showSuccessNotification } from '../../Services/Notifications';
import { Constants } from '../../Utils/Constants';
import { ErrorMessages } from '../../Utils/Messages';
import { Appheaders, formatAmountWithCommas, panValidate, setAlpha, setAlphaNumeric, setEmailValidation, setNumeric } from '../../Utils/utils';
import './RateCalculator.scss';


const allProducts = [

  // Don't Change the Order of this List
  "Telegraphic Transfer",
  "Buy Currency",
  "Sell Currency",
  "Buy Card",
  "Sell Card",
  "Reload Card"

];



// const panRegex = /^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/;

const Ratecalculator = () => {
  const [show, setShow] = useState(false);
  const [showRateError, setShowRateError] = useState(false);
  const [tcsAmount, setTcsAmount] = useState(0);
  const [showConfirmation,setShowConfirmation]=useState(false)
  const [tempType,setTempType]=useState("")
  const handleCloseConfirmation=()=>{
    setShowConfirmation(false)
  }
  
  const handleClose = () => setShow(false);
  const handleShow = () => {

    if(fieldChangeFlag){
      showInfoNotification("Please Click on Calculate to view Latest Quotation Details")
      return;
    }
    else
    setShow(true)
  };



  const [showRefresh, setShowRefresh] = useState(false);
  const [fieldChangeFlag,setFieldChangeFlag]=useState(false);
  const [flagProductName, setFlagProductName] = useState("");

  const productTypeMapper=(ProductName)=>{  
    switch (ProductName){

      case allProducts[0]:
        return "TT"
       
      case allProducts[1]:
        return "CN"
       

      case allProducts[2]:
        return "CN"
      
      default:
        return "FC"
    }
  }



  
  const [bill, setBill] = useState({})
  const [customerDetails, setCustomerDetails] = useState({

    s_full_name: "",
    s_email: "",
    s_mobile: "",
    r_full_name: "",
    r_email: "",
    r_mobile: "",
    r_pref_bank: "ICICI Bank"


  });

  const [allCurrenciesData, setAllCurrenciesData] = useState({});
  const [inputData, setInputData] = useState({

    type: "sale_under_lrs",
    specifiedPerson: false,
    educationLoan: false,
    trxnOthrDelr: false,
    trxnWithOtherDealersAmount: "",
    transactionFee: "",
    panNo: ""

  })
  const [productsData, setProductsData] = useState([{
    productType: "",
    currencyCodes: "",
    productName: "",
    definedRate: "",
    fxAmount: "",
  }])

  // const fetchAllProducts = async () => {
  //   let response = await axios.get(`${process.env.REACT_APP_BACKEND_HOST}services/ratecalc/product-list`);
  //   let products = response.data.data;
  //   setAllProducts(products)
  // }

  const refQuotButton = useRef(null);

  // useEffect(() => {
  //   fetchAllProducts()

  // }, [])


  const fetchAllCurrencies = async () => {
    let response = await axios.get(`${process.env.REACT_APP_BACKEND_HOST}services/ratecalc/currencies-list`);
    let currencies = response.data.data;
    let productCurrencyMap = {};
    currencies?.map(item => {
      if (item?.product_name)
        if (!productCurrencyMap?.[item?.product_name])
          productCurrencyMap[item?.product_name] = [item];
        else
          productCurrencyMap[item?.product_name].push(item);
    });
    setAllCurrenciesData(productCurrencyMap);
  }

  useEffect(() => {
    fetchAllCurrencies();
    //The call will start after 30 sec. Thus we called before
    const interval = setInterval(() => {
      // Update the count state every second
      fetchAllCurrencies();
    }, 30000); // Interval set to 1000ms (1 second)

    // Clear the interval when the component unmounts or as needed
    return () => clearInterval(interval);
  }, []);

  const handleAdd = () => {
    if(productsData[0].productName==allProducts[0])
      return;
    // console.log("product type", productsData[0].productType);
    setProductsData((pre) => {

      return [...pre, {

        productType:productsData[0].productType,
        currencyCodes: "",
        productName: "",
        definedRate: "",
        fxAmount: "",


      }]

    });

  }

  const handleDelete = (ind) => {

    let updatedProducts = productsData.filter((product, index) => index != ind)
    setProductsData(updatedProducts);
    if (updatedProducts?.length === 1) {
      setFlagProductName("");
    }
  }

  const handleCustomerDetailsChange = (e) => {

    let name = e.target.name;
    let value = e.target.value;

    if(name==='s_mobile' || name==='r_mobile'){
      if( (value+"").length>10)
      return;
    }
    setCustomerDetails((details)=>{
      return{
        ...details,
        [name]:value
      }

    })
  }

  const handleInputChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    if(name==='type')
    {
      setShowConfirmation(true)
      setTempType(value)
      return;
    } else if (name === 'panNo') {
      value = value.toString().toUpperCase();
    }

    if (value == 'true')
      value = true;
    else if (value == 'false')
      value = false;


    setInputData((data) => {
      return {
        ...data,
        [name]: value
      }
    })

    if(bill.currency)
    {
      setFieldChangeFlag(true)
    }
  }

  const handleProductInputChange = (e, index) => {
    const name = e.target.name;
    const value = e.target.value;

    if (bill.currency) {
      setFieldChangeFlag(true)
    }

    if (index === 0 && name === 'productName') {
      // console.log("val", value);
      setFlagProductName(value)
      if (value === allProducts[2] || value === allProducts[4]) {
        setInputData((pre) => {
          return {
            ...pre,
            type:'purchase'
          }
        })
      } else {
        setInputData((pre) => {
          return {
            ...pre,
            type:'sale_under_lrs'
          }
        })
      }
    }
    // alert(n)
    const updatedProducts = [...productsData]
    if (name === 'productName') {
      updatedProducts[index] = {
        currencyCodes: '',
        definedRate: '',
        fxAmount: ''
      }
      if (index == 0) {
        updatedProducts[index].productType = '';
      } else {
        updatedProducts[index].productType = updatedProducts[0].productType;
      }
    } else if (name === 'currencyCodes') {
      let product = updatedProducts[index].productName;
      if (!product)
        return;
      let currencyVal = allCurrenciesData[productTypeMapper(product)].find(item => item.code === value);
      currencyVal = (product?.toLowerCase()?.includes('sell'))? currencyVal.finalSellRate: currencyVal.finalBuyRate;
      updatedProducts[index].definedRate = currencyVal;
    } else if (name === 'definedRate') {
      let product = updatedProducts[index].productName;
      let currencyCode = updatedProducts[index].currencyCodes;
      let currencyVal = allCurrenciesData[productTypeMapper(product)].find(item => item.code === currencyCode);
      if (product?.toLowerCase()?.includes('sell')) {
        currencyVal = currencyVal.finalSellRate;
        // value decreases from final value remove error
        if (currencyVal > value) {
          setShowRateError(false);
        } else {
          setShowRateError(true);
        }
      } else {
        currencyVal = currencyVal.finalBuyRate;
        // value decreases from final value show error
        if (currencyVal > value) {
          setShowRateError(true);
        } else {
          setShowRateError(false);
        }
      }
      updatedProducts[index].definedRate = currencyVal;
    }


    updatedProducts[index] = {
      ...updatedProducts[index],
      [name]: value,

    }
    setProductsData(updatedProducts);

  }

  const validateProducts = (commonData, productsData) => {

    let isValid = true;
    let message = "";
    if (!commonData.transactionFee){
      isValid = false;
      message = ErrorMessages.TransactionFees;
    }

    if (commonData.trxnOthrDelr && !commonData.trxnWithOtherDealersAmount){
      isValid = false;
      message = ErrorMessages.TransactionWithOtherDealer;
    }
    if (commonData.panNo && !panValidate(commonData.panNo)) {
      isValid = false;
      message = ErrorMessages.PanNo;
    }

    // Now Valid Products Data
    for (let i = 0; i < productsData.length; i++) {
      let product = productsData[i];
      console.log("product", i, product);
      let { productType, currencyCodes, productName, definedRate, fxAmount } = product;
      // Assign bool to check the product type exist or condition product is sell product;
      productType = productType || flagProductName === allProducts[2] || flagProductName === allProducts[4];
      let count = 0;
      if (!productName){
        count++;
        message = ErrorMessages.ProductName;
      }
      if (!productType) {
        count++;
        message = ErrorMessages.ProductType;
      }
      if (!currencyCodes) {
        count++;
        message = ErrorMessages.CurrencyCode;
      }
      if (!definedRate) {
        count++;
        message = ErrorMessages.DefinedRate;
      }
      if (!fxAmount) {
        count++;
        message = ErrorMessages.FxAmount;
      }
      if (!productType || !currencyCodes || !productName || !definedRate || !fxAmount) {
        isValid = false;
        if (count > 1){
          message = ErrorMessages.MultiMissing;
        }
        break;
      }

    }

    return {isValid, message};
  }

 
  const handleCalculate = async () => {
    showInfoNotification("Calculation is in progress...");
    const dataToSend = {
      commonData: inputData,
      productsData: productsData
    }
    if (showRateError) {
      //rate error message
      showErrorNotification(ErrorMessages.LossMessage);
      return;
    }

    const validate = validateProducts(inputData, productsData);
    if (!validate?.isValid) {
      showErrorNotification(validate.message);
      return;
    }
    if (flagProductName === allProducts[2] || flagProductName === allProducts[4]) {
      dataToSend.commonData.type = 'purchase';
    } else {
      dataToSend.commonData.type = 'sale_under_lrs';
    }
    

    let response = await axios.post(`${process.env.REACT_APP_BACKEND_HOST}services/ratecalc/calc-rate`, dataToSend);

    if (response?.data?.responseCode === 400) {
      showErrorNotification("Please try again.");
      return;
    }

    let final_bill = response.data.remittance_rate.data;
    if (+final_bill.final_bill_amount < 0) {
      showErrorNotification("The amount is too small to count.");
      return;
    }
    showSuccessNotification("Latest quote successfully fetched.");
    if (inputData.panNo) {
      final_bill.panNo = inputData.panNo;
    }
    if (final_bill?.tcs_value) {
      setTcsAmount(final_bill.tcs_value);
    } else {
      setTcsAmount(0);
    }
    const options = { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true };
    const now = new Date().toLocaleString('en-US', options);
    final_bill.currentDate = now;
    setBill(final_bill)
    setFieldChangeFlag(false)

  }

  const handleSendQuot=()=>{
    refQuotButton.current.disabled = true;
    let {s_full_name,s_email,s_mobile,r_full_name,r_name,r_email,r_mobile,r_pref_bank}=customerDetails

    if(!s_full_name||!s_email||!s_mobile||!r_full_name||!r_email||!r_mobile||!r_pref_bank)
    {
      showErrorNotification("Fill all the required fields");
      refQuotButton.current.disabled = false;
      return;
    }
    
    
    
    
    const sendQuotationToUser = async () => {
      showInfoNotification("Sending the details to the user...");
      let bankList = ['ICICIBANK', 'HDFCBANK', 'YESBANK'];
      let prefBank = r_pref_bank;
      if (prefBank === 'ICICI Bank') {
        prefBank = bankList[0];
      } else if (prefBank === 'HDFC Bank') {
        prefBank = bankList[1];
      } else if (prefBank === 'YES Bank') {
        prefBank = bankList[2];
      }
      let productsToSend = productsData?.map(item => {
        let pData = {
          currency: item?.currencyCodes,
          fxamount: item?.fxAmount,
          defined_rate: +item?.definedRate,
          product: item?.productName,
          product_type: item?.productType,
        }
        return pData;
      })

      try {
        let headers = Appheaders();
        let body = {
          name: s_full_name,
          email: s_email,
          mobile: s_mobile,
          r_name,
          r_email,
          r_mobile,
          pref_bank: prefBank || bankList[0],
          transactionfee: inputData?.transactionFee,
          transactionwithotherdealer: inputData?.trxnWithOtherDealersAmount,
          type: inputData?.type,
          educationloan: inputData?.educationLoan,
          specifiedperson: inputData?.specifiedPerson,
          products: productsToSend
        }
        if (inputData.panNo  && productsData?.[0]?.productType && tcsAmount) {
          body.panNumber = inputData.panNo;
          body.product_type = productsData[0].productType;
          body.calculatedTCS = tcsAmount;
        }
        await axios.post(`${Constants.COMMON_BACKEND_URL}rapi/quotation/send`, body, { headers: headers });
        showSuccessNotification("The mail has been sent successfully.");
        handleClose();
      } catch(e) {
        showErrorNotification("Please try again.");
        console.log(e);
      } finally {
        refQuotButton.current.disabled = false;
      }
    }
    sendQuotationToUser();
  }

  const handleConfirmationYes=()=>{

    setInputData((data)=>{

      return {

        ...data,
        type:tempType
      }
    })

    setProductsData([{
      productType: "",
      currencyCodes: "",
      productName: "",
      definedRate: "",
      fxAmount: "",
    }])

    setBill({})
    handleCloseConfirmation();

  }

  
  let currencyCodeValue = productsData?.reduce((acc, curVal) => {
    if (curVal?.currencyCodes && !acc?.filter(item => item?.currencyCodes === curVal.currencyCodes && item?.productName === curVal.productName)?.length) {
      acc.push(curVal);
    }
    return acc;
  }, []);
  let condToShowEducationLoan = true;
  let purposeArrForNotEduLoan = ['Guaranteed Investment Certificate','Examination Fee','Medical Treatment Abroad','Emigration Fee Payment','VISA Fee Payment','Leisure Travel', 'Medical Treatment', 'Personal Trip'];
  if (productsData.length && productsData?.[0]?.productType && purposeArrForNotEduLoan.includes(productsData[0].productType)) {
    condToShowEducationLoan = false;
  }
  return (
    <>
      <div className='container' id='RateCalc'>
        <div className='row'>
          <div className='col-md-7'>
            <div className='mainbx'>

              <div className='row'>
                <h1>
                  Rate Calculator
                  {!!currencyCodeValue?.length &&
                    <div className='info-container'>
                      <IoIosInformationCircleOutline className='info-icon' />
                      <div className="info-text">
                        <ul>
                          {currencyCodeValue?.map(item => {
                            if (item?.productName && item?.currencyCodes) {
                              let currencyVal = allCurrenciesData[productTypeMapper(item.productName)].find(currData => currData.code === item.currencyCodes);
                              currencyVal = (item.productName?.toLowerCase()?.includes('sell'))? currencyVal.finalSellRate: currencyVal.finalBuyRate;
                              return <li>{productTypeMapper(item.productName)} {item.currencyCodes} - {currencyVal}</li>
                            }
                          })}
                        </ul>
                      </div>
                    </div>
                  }
                </h1>
              </div>




              {productsData && productsData?.map((product, index) => {

                return <div className='row mb-3 multi__cards'>

                  <div className='col-md-12 multicards'>
                    <div className='row'>

                      <div className='col-md-4 mb-3'>
                        <label htmlFor="">Product<span className='red'>*</span></label>
                        <select name='productName' className='form-select'
                         onChange={(e) => { handleProductInputChange(e, index) }}
                          value={productsData[index].productName}>

                          <option value="">Select Product</option>
                          {allProducts.map((pro) => {
                            

                             if(productsData.length>1){

                               if (pro ==allProducts[0]) {
                                return <></>;
                               } else if (flagProductName === allProducts[1] || flagProductName === allProducts[3] || flagProductName === allProducts[5]) {
                                if (pro === allProducts[1] || pro === allProducts[3] || pro === allProducts[5])
                                 return <option value={pro}>{pro}</option>
                                else 
                                  return <></>
                              } else if (flagProductName === allProducts[2] || flagProductName === allProducts[4]) {
                                if (pro === allProducts[2] || pro === allProducts[4])
                                  return  <option value={pro}>{pro}</option>
                                else
                                  return <></>
                               } else if (!flagProductName) {
                                 return <option value={pro}>{pro}</option>
                               } else {
                                 return <></>
                               }
                           
                            } else{
                              return  <option value={pro}>{pro}</option>

                            }
                          })}

                        </select>
                      </div>
                      {!(flagProductName === allProducts[2] || flagProductName === allProducts[4]) &&
                        <div className='col-md-4 mb-3'>
                          <label htmlFor="">Purpose<span className='red'>*</span></label>
                          <select name='productType' className='form-select' onChange={(e) => { handleProductInputChange(e, index) }} value={productsData[0].productType} disabled={index > 0 ? true : false} >
                            <option value="">Select Purpose</option>
                            {productsData[index]?.productName && Constants.PRODUCT_TYPE[productTypeMapper(productsData[index]?.productName)]?.map((product) => {

                              return <option value={product}>{product}</option>
                            })}
                          </select>
                        </div>
                      }
                      <div className='col-md-4 mb-3'>
                        <label >Currency<span className='red'>*</span></label>

                        <select name='currencyCodes' className='form-select' onChange={(e) => { handleProductInputChange(e, index) }} value={productsData[index].currencyCodes}>
                          <option value="">Select Currency </option>
                          {!!allCurrenciesData && !!productsData?.[index]?.productName && allCurrenciesData?.[productTypeMapper(productsData?.[index]?.productName)]?.map((c) => {

                            return <option value={c.code}>{c.code}</option>
                          })}
                          {/* <option  value="USD">USD</option>
                        <option  value="TWD">TWD</option> */}
                        </select>
                      </div>
                      <div className='col-md-4 mb-3'>
                        <label htmlFor="">Rate<span className='red'>*</span></label>
                        <input className={'form-control '  + (showRateError ? "red-imp" : "")}name='definedRate' onKeyDown={setNumeric} onChange={(e) => { handleProductInputChange(e, index) }} value={productsData[index].definedRate} type="number" placeholder='Enter Rate' />
                      </div>
                      <div className='col-md-4 mb-3'>
                        <label htmlFor="">FX Amount<span className='red'>*</span></label>
                        <input className='form-control' name='fxAmount' min={0} onKeyDown={setNumeric} onChange={(e) => { handleProductInputChange(e, index) }} value={productsData[index].fxAmount} type="number" placeholder='Enter Amount' />
                      </div>
                      <div className='col-md-4'>
                        <div className='action-btns'>
                          {(index + 1 == productsData.length) && (productsData[0].productName!=="") && (productsData[0].productName!==allProducts[0])  && <a onClick={handleAdd} href='javascript:void(0)'>
                            <img src='https://remitxb2c.s3.ap-south-1.amazonaws.com/1699016061744-add-icon.png' width="30" height="30" />
                          </a>}
                          {productsData.length != 1 && <a onClick={() => { handleDelete(index) }} className="trash_del" href="javascript:void(0);"><img src="https://remitxb2c.s3.ap-south-1.amazonaws.com/1697109392507-trash.png" width="" height="" /> </a>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>



              })}

              <div className='row'>
                <div className='col-md-4 mb-3'>
                  <label className='type'>Transaction Fees<span className='red'>*</span></label>
                  <input type="text" name="transactionFee" className="form-control" placeholder="Please Enter" onKeyDown={setNumeric} onChange={handleInputChange} value={inputData.transactionFee} />
                </div>
                <div className='col-md-4 mb-3'>
                  <label className='type'>Payer Pan</label>
                  <input type="text" name="panNo" maxLength={10} className="form-control" placeholder="Please Enter" onKeyDown={setAlphaNumeric} onChange={handleInputChange} value={inputData.panNo} />
                </div>
              </div>
              {!(flagProductName === allProducts[2] || flagProductName === allProducts[4]) &&
                <div className='row mrg-t25'>
                  <div className='col-md-6 mb-3'>
                    <label className='type'>Specified Person</label>
                    <div className="form-check">


                      <input type="radio" name='specifiedPerson' className='form-check-input' onChange={handleInputChange} value={true} checked={inputData.specifiedPerson} />
                      <label className="form-check-label" for="specifiedPerson">
                        Yes
                      </label>
                    </div>
                    <div className="form-check">
                      <input type="radio" name='specifiedPerson' className='form-check-input' onChange={handleInputChange} value={false} checked={!inputData.specifiedPerson} />
                      <label className="form-check-label" for="specifiedPerson">
                        No
                      </label>
                    </div>
                  </div>
                  {condToShowEducationLoan && 
                    <div className='col-md-6 mb-3'>
                      <label className='type'>Education Loan</label>
                      <div className="form-check">
                        <input type="radio" className='form-check-input' name='educationLoan' onChange={handleInputChange} value={true} checked={inputData.educationLoan} />
                        <label className="form-check-label" for="educationLoan">
                          Yes
                        </label>
                      </div>
                      <div className="form-check">
                        <input type="radio" className='form-check-input' name='educationLoan' onChange={handleInputChange} value={false} checked={!inputData.educationLoan} />
                        <label className="form-check-label" for="educationLoan">
                          No
                        </label>
                      </div>
                    </div>
                  }
                  <div className='col-md-6 mb-3'>
                    <label className='type'>Transaction With Other Dealer</label>
                    <div className="form-check">
                      <input type="radio" className='form-check-input' name='trxnOthrDelr' onChange={handleInputChange} value={true} checked={inputData.trxnOthrDelr} />
                      <label className="form-check-label" for="trxnOthrDelr">
                        Yes
                      </label>
                    </div>
                    <div className="form-check">
                      <input type="radio" className='form-check-input' name='trxnOthrDelr' onChange={handleInputChange} value={false} checked={!inputData.trxnOthrDelr} />
                      <label className="form-check-label" for="trxnOthrDelr">
                        No
                      </label>
                    </div>
                  </div>
                  {/* <div className='col-md-4 mb-3'>
                    <label className='type'>Transaction Fees</label>
                    <input type="text" name="transactionFee" className="form-control" placeholder="please enter" onKeyDown={setNumeric} onChange={handleInputChange} value={inputData.transactionFee} />
                  </div> */}

                  {/*  */}

                  {inputData.trxnOthrDelr === true && <div className='col-md-4 mb-3'>
                    <label className='type'>Amount</label>
                    <input type="text" name="trxnWithOtherDealersAmount" className="form-control" placeholder="please enter" onChange={handleInputChange} value={inputData.trxnWithOtherDealersAmount} />
                  </div>}

                  {/*  */}
                </div>
              }
              <div className='col-md-12'><button className='btn btn-outline-primary' onClick={handleCalculate}>Calculate</button></div>

            </div>
          </div>
          {bill.currency && <div className='col-md-5 pos_rel'>
            <div className='mainbx fixed-right'>
              {/* {showRefresh&&<button id="refresh-button" className='btn btn-primary ' onClick={handleCalculate}>Refresh</button>} */}
              <h1>
                Quotation
                {bill?.currentDate && 
                <span class="right-aligned font14">{bill.currentDate}</span>}
              </h1>

              <div className='table-responsive'>
                <table className='table tbl'>
                  <thead>
                    <tr>
                      <th scope="col" className='table-active'>Purchase</th>
                      <th scope="col" className='table-active'>FX Amount</th>
                      <th scope="col" className='table-active'>Rate</th>
                      <th scope="col" className='table-active'>INR</th>
                    </tr>
                  </thead>
                  <tbody>

                    {bill?.currency?.map((data, index) => {

                      return <tr>
                        <td width='30%'>{data}</td>
                        <td width='25%'>{bill.fx_amount[index]}</td>
                        <td width='25%'>{bill.rate[index]}</td>
                        <td width='20%'>{formatAmountWithCommas(bill.fx_currency_prices[index])}</td>
                      </tr>

                    })}
                    <tr>
                      <td className='table-active'></td>
                      <td className='table-active'>Forex INR Total</td>
                      <td className='table-active'></td>
                      <td className='table-active'>{formatAmountWithCommas(bill.fx_inr_total)}</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>GST on Fx Value</td>
                      <td></td>
                      <td>{formatAmountWithCommas(bill.gst_fx_value)}</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>Trans. Fee</td>
                      <td></td>
                      <td>{formatAmountWithCommas(bill.transaction_fee)}</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>GST on Trans. Fee</td>
                      <td></td>
                      <td>{formatAmountWithCommas(bill.gst_transaction_fee)}</td>
                    </tr>
                    {bill?.panNo && !(flagProductName === allProducts[2] || flagProductName === allProducts[4]) &&
                      <tr>
                        <td></td>
                        <td>TCS</td>
                        <td></td>
                        <td>{formatAmountWithCommas(bill.tcs_value)}</td>
                      </tr>
                    }
                    <tr>
                      <td className='table-active'></td>
                      <td className='table-active'>Bill Amount</td>
                      <td className='table-active'></td>
                      <td className='table-active'>{formatAmountWithCommas(bill.final_bill_amount ?? bill.total_bill_amount)}</td>
                    </tr>
                  </tbody>
                </table>
                {
                  !bill?.panNo && !(flagProductName === allProducts[2] || flagProductName === allProducts[4]) && 
                  <div className='note'>Note: TCS will be applicable on the Payer Pan.</div>
                }
                <div className='col-md-12'>
                  <button className='btn btn-primary' onClick={handleShow}>Send Quotation</button>
                </div>
              </div>
            </div>
          </div>}
        </div>
      </div>
      {/* <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button> */}

      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <div className='col-md-12 userdetails'>
            <div className='row'>
              <h6>User Details</h6>
              <div className='col-md-4 mb-3'>
                <label for="exampleFormControlInput1" className='form-label'>Full Name<span className='red'>*</span></label>
                <input onChange={handleCustomerDetailsChange} name='s_full_name' type="text" className="form-control" id="exampleFormControlInput1" placeholder="Enter Full Name" onKeyDown={setAlpha} value={customerDetails.s_full_name} />
              </div>
              <div className='col-md-4 mb-3'>
                <label for="exampleFormControlInput1" className='form-label'>Email<span className='red'>*</span></label>
                <input onKeyDown={setEmailValidation} onChange={handleCustomerDetailsChange} name='s_email' type="email" className="form-control" id="exampleFormControlInput1" placeholder="Enter email" value={customerDetails.s_email} />
              </div>
              <div className='col-md-4 mb-3'>
                <label for="exampleFormControlInput1" className='form-label'>Mobile<span className='red'>*</span></label>
                <input onChange={handleCustomerDetailsChange} name='s_mobile' type="text" className="form-control" onKeyDown={setNumeric} id="exampleFormControlInput1" placeholder="Enter Mobile No." value={customerDetails.s_mobile} />
              </div>
            </div>
            <div className='row mrg-t15'>
              <h6>Remitter Details</h6>
              <div className='col-md-4 mb-3'>
                <label for="exampleFormControlInput1" className='form-label'>Full Name<span className='red'>*</span></label>
                <input onChange={handleCustomerDetailsChange} name='r_full_name' type="text" className="form-control" onKeyDown={setAlpha} id="exampleFormControlInput1" placeholder="Enter Full Name" value={customerDetails.r_full_name} />
              </div>
              <div className='col-md-4 mb-3'>
                <label for="exampleFormControlInput1" className='form-label'>Email<span className='red'>*</span></label>
                <input onKeyDown={setEmailValidation} onChange={handleCustomerDetailsChange} name='r_email' type="email" className="form-control" id="exampleFormControlInput1" placeholder="Enter email" value={customerDetails.r_email} />
              </div>
              <div className='col-md-4 mb-3'>
                <label for="exampleFormControlInput1" className='form-label'>Mobile Number<span className='red'>*</span></label>
                <input onChange={handleCustomerDetailsChange} name='r_mobile' type="text" className="form-control" onKeyDown={setNumeric} maxLength={10} id="exampleFormControlInput1" placeholder="Enter Mobile No." value={customerDetails.r_mobile} />
              </div>
              <div className='col-md-4 mb-3'>
                <label for="exampleFormControlInput1" className='form-label'>Payer Preferred Bank Name<span className='red'>*</span></label>
                <select onChange={handleCustomerDetailsChange} name='r_pref_bank' className='form-select' value={customerDetails.r_pref_bank}>
                  <option value="ICICI Bank">ICICI Bank</option>
                  <option value="HDFC Bank">HDFC Bank</option>
                  <option value="YES Bank">YES Bank</option>
                </select>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary mrg-t0" onClick={handleClose}>
            Close
          </Button>
          <Button ref={refQuotButton} variant="primary mrg-t0" onClick={handleSendQuot}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>

      {/*  */}

      <Modal size="md" show={showConfirmation} onHide={handleCloseConfirmation}>


        <Modal.Header closeButton>
          <Modal.Title>Are You Sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <div className='col-md-12 userdetails'>
            <div className='row'>
              <p className='font14'>All the filled details will be lost (if any).</p>
              
            </div>
             

             <div id='areyousure' className='text-right'>
            <Button variant="primary mrg-t0 mrg-r15" onClick={handleConfirmationYes}>
            Yes
          </Button>
          <Button  variant="outline-primary mrg-t0" onClick={handleCloseConfirmation}>
            No
          </Button>
          </div>
            
          </div>

        </Modal.Body>
       
      </Modal>
    </>
  )
}

export default Ratecalculator;





